import { Set, Get } from "../../../../../Request";
import { useState } from "react";
export const CreateClassManager = () => {
  const [loading, setLoading] = useState(false);

  const formSubmit = async data => {
    setLoading(true);
    Set({
      url: "/clientmanagment/newclient",
      data: { ...data, role: "classmanager" },
    }).then(() => {
      setLoading(false);
    });
  };
  return { formSubmit, loading };
};
export const useListOfClassManager = () => {
  const [loading, setLoading] = useState({
    getDataLoading: false,
    deletDataLoading: false,
  });
  const [data, setData] = useState();
  const [showModal, setshowModal] = useState(false);
  const getData = async () => {
    setLoading({ ...loading, getDataLoading: true });
    Get({
      url: "/clientmanagment/show_list",
      data: { role: "classmanager" },
    }).then(res => {
      setLoading({ ...loading, getDataLoading: false });
      setData(res);
      setshowModal(false);
    });
  };

  const deletData = data => {
    setLoading({ ...loading, deletDataLoading: true });

    Set({
      url: "/clientmanagment/destroy",
      data: data,
    }).then(() => {
      getData().then(res => {
        setData(res);
        setLoading({ ...loading, deletDataLoading: false });
      });
    });
  };

  const editUser = async data => {
    setLoading({ ...loading, edit: true });
    Set({
      url: "/clientmanagment/update",
      data: { ...data, client_id: showModal },
    }).then(() => {
      getData().then(res => {
        setData(res);

        setLoading({ ...loading, edit: false });
      });
    });
  };

  return {
    getData,
    data,
    loading,
    deletData,
    editUser,
    showModal,
    setshowModal,
  };
};
// const HandlerDelete = (data) => {
//   setstate({ ...state, loading: true });
//   DeleteData(data).then(() => {
//     GetData().then((result) => {
//       setstate({
//         loading: false,
//         data: result,
//       });
//     });
//   });
// };
// export const DeleteData = async data => {
//   await Remove({
//     url: "/clientmanagment/destroy",
//     data: data,
//   });
// };
